<template>
  <div class="activity-wrap">
    <app-header />
    <div class="banner_main">
      <div class="content_box">
        <img
          src="../../assets/images/activity/activityforecast2024/big_note_text.png"
        />
      </div>
    </div>
    <div class="content_main">
      <div class="main_box">
        <div class="xxtx-detail-bd xxtx-detail-byTime">
          <section
            class="xxtx-detail-item"
            v-for="(item, index) in list"
            :key="index"
          >
            <template>
              <h3>
                {{ item.name }}
              </h3>
              <div class="date">
                {{ item.time }}
              </div>
            </template>
          </section>
        </div>
      </div>
    </div>
    <p class="footer_box">投资有风险，入市需谨慎</p>
  </div>
</template>
    <script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      token: "",
      list: [
        {
          name: "中国证监会及交易所等发布全面实行股票发行注册制制度规则",
          time: "2月17日",
        },
        {
          name: "主板注册制首批10家企业4月10日上市，十家主板注册制新股涨幅均超40%",
          time: "4月10日",
        },
        {
          name: "中共中央政治局召开会议，要活跃资本市场，提振投资者信心，次日三大指数高开大涨超2%",
          time: "7月24日",
        },
        { name: "证监会：确定活跃资本市场一揽子政策措施", time: "8月21日" },
        { name: "向投资者让利，六家券商下调佣金费率", time: "8月25日" },
        {
          name: "证券交易印花税实施减半征收，沪指高开5%，全天高开低走，一分钟“牛市”，最终收盘仅上张1.13%",
          time: "8月28日",
        },
        {
          name: "证监会发布高质量建设北京证券交易所意见，北证50大涨5.92%",
          time: "9月4日",
        },
        {
          name: "促进流动性提升 北交所研究探索引入私募机构参与做市",
          time: "9月21日",
        },
        {
          name: "汇金公司增持四大行股份，拟未来6个月内继续在二级市场增持，随后7个交易日沪指下跌5.43%",
          time: "10月12日",
        },
        {
          name: "中央汇金当日买入交易型开放式指数基金（ETF），并将在未来继续增持，随后一周指数上张2.8%。",
          time: "10月23日",
        },
        { name: "我国将增发2023年国债1万亿元", time: "10月25日" },
        { name: "易会满：全力维护资本市场平稳运行", time: "12月5日" },
      ],
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {},
  methods: {},
};
</script>
    <style lang="scss" scoped>
// 清除浮动
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.activity-wrap {
  background: #ededed;
  overflow: hidden;
  overflow: hidden;
  .banner_main {
    width: 100%;
    height: 220px;
    margin-bottom: 22px;
    background: url("../../assets/images/activity/activityforecast2024/big_note_banner.png")
      no-repeat;
    background-size: 100% 100%;
    .content_box {
      width: 900px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
      box-sizing: border-box;
      img {
        width: 827px;
        height: 175px;
      }
    }
  }
  .content_main {
    width: 900px;
    margin: 0 auto;
    background-color: #fff;
    padding: 50px 20px 37px;
    box-sizing: border-box;
    .main_box {
      width: 100%;
    }
  }
  .footer_box {
    margin: 27px 0;
    text-align: center;
    font-size: 12px;
    color: rgba(85, 85, 85, 0.3);
  }

  .xxtx-detail-item {
    padding: 0 14px 35px 150px;
    color: rgba(119, 119, 119, 1);
    position: relative;
    z-index: 1;
  }
  .xxtx-detail-item:before,
  .holder-detail .date:before {
    content: "";
    position: absolute;
    left: 105px;
    top: 10px;
    width: 1px;
    bottom: -60px;
    background: rgba(105, 189, 250, 1);
    z-index: -1;
  }
  .xxtx-detail-item:after,
  .holder-detail .date:after {
    content: "";
    position: absolute;
    left: 100px;
    top: 7px;
    width: 12px;
    height: 12px;
    background: rgba(105, 189, 250, 1);
    border-radius: 100%;
  }
  .xxtx-detail-item h3 {
    font-size: 16px;
    margin-bottom: 3px;
  }
  .xxtx-detail-item h3 a,
  .xxtx-timeLine li h6 a {
    color: #5793f1;
  }
  .xxtx-detail-item h3 a:after,
  .xxtx-timeLine li h6 a:after,
  .xxtx-detail-item p {
    font-size: 16px;
    color: #aab9d1;
    margin-top: 10px;
    word-break: break-all;
  }
  .xxtx-detail-item p a {
    font-size: 14px;
    color: #5d82bb;
    display: inline-block;
  }
  .xxtx-detail-item .date {
    position: absolute;
    left: 10px;
    top: 4px;
    font-size: 15px;
    text-align: right;
    line-height: 1.2;
    width: 70px;
    text-align: right;
  }
  .xxtx-detail-item .date small {
    font-size: 12px;
    color: #888;
  }
  .arrow-more {
    display: inline-block;
    padding: 0 10px;
    position: relative;
    cursor: pointer;
  }
  .arrow-more:before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    border-bottom: 1px solid #7c8794;
    border-right: 1px solid #7c8794;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    vertical-align: 2px;
  }
  .arrow-more.up:before {
    -webkit-transform: rotate(-135deg);
    -ms-transform: rotate(-135deg);
    transform: rotate(-135deg);
    vertical-align: -2px;
  }
  .more-text {
    font-size: 14px;
    color: #7c8794;
    background: #1a202b;
    padding: 10px 12px;
    margin-top: 15px;
    position: relative;
    display: none;
    text-align: justify;
  }
  .more-text a {
    color: #5d82bb;
    font-size: 14px;
    display: inline-block;
  }
  .more-text:before {
    content: "";
    position: absolute;
    left: 18px;
    top: -14px;
    width: 0;
    height: 0;
    border: 7px solid transparent;
    border-bottom: 7px solid #1a202b;
  }
  .xxtx-detail-column {
    height: 25px;
    margin-bottom: 20px;
    padding-right: 14px;
  }
  .xxtx-detail-column a {
    color: #7c8794;
    position: relative;
    padding-right: 8px;
    z-index: 3;
    font-size: 13px;
    line-height: 25px;
  }
  .xxtx-detail-column span {
    float: left;
    line-height: 25px;
    width: 77px;
    text-align: center;
    font-size: 14px;
    color: #5793f1;
    background: #1a202b;
    position: relative;
    z-index: 1;
  }
  .xxtx-detail-item:last-child:before {
    bottom: -10px;
  }
  .xxtx-detail-moreTit {
    line-height: 40px;
    font-size: 16px;
    color: #d5dce5;
    padding: 0 18px;
    position: relative;
  }
  // .xxtx-detail-byTime .xxtx-detail-item:first-child:after {
  //   background: #3b85fe;
  //   border: 3px solid #2e333d;
  //   left: 58px;
  // }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activityBigNote2023.vue